/**
 * @ignore
 */
const BufferDrawTool = require('./BufferDrawTool');
class DrawLineTool extends BufferDrawTool {
    constructor(opts) {
        super(opts);
        //
        this.defaultSymbol = new g2.sfs.SimpleLineSymbol();
    }
    onMouseUp(button, shift, screenx, screeny, mapx, mapy, handled) {
        if (this.drawing) {
            const point = [mapx, mapy];
            this.points.push(point);
            // console.debug('add point ', point);
            this._updateElement(false);
        }
    }
    onMouseMove(button, shift, screenx, screeny, mapx, mapy, handled) {
        if (this.drawing && this.points.length > 0) {
            const point = [mapx, mapy];
            this.movingPoint = point;
            this._updateElement(true);
        }
    }

    onDblclick(button, shift, screenx, screeny, mapx, mapy, handled) {
        if (this.drawing 
            && this.params.layer.getCount() > 0 
            && this.points.length > 1 ) {
            const element = this.params.layer.get(0);
            const geometry = element.geometry;
            const path = geometry.getGeometry(0);
            if (path.getPointCount() > 2) {
                const count = this.points.length;
                const lastPt0 = this.points[count-1];
                const lastPt1 = this.points[count-2];
                if (lastPt0[0] === lastPt1[0] && lastPt0[1] === lastPt1[1]) {
                    path.removePoint(path.getPointCount()-1);
                }
                this.drawing = false;
                this.params.callback.call(this.params.context, element);
            }
        }
    }

    _updateElement(appendMovingPoint) {
        const path = new g2.sfs.Path();
        const spatialReference = this.options.map.spatialReference;
        for (let i = 0;i<this.points.length;i++) {
            const point=new g2.sfs.Point({
                x: this.points[i][0],
                y: this.points[i][1],
                spatialReference,
            });
            path.addPoint(point);
        }
        if (appendMovingPoint) {
            const point=new g2.sfs.Point({
                x: this.movingPoint[0],
                y: this.movingPoint[1],
                spatialReference,
            });
            path.addPoint(point);
        }
        if (path.getPointCount() > 1) {
            const geometry = new g2.sfs.Polyline();
            geometry.addGeometry(path);
            if (this.params.layer.getCount() === 0) {
                const element = new g2.sfs.Element({
                    geometry,
                    symbol: this.symbol,
                });
                this.params.layer.add(element);
            } else {
                const element = this.params.layer.get(0);
                element.geometry = geometry;
                this.params.layer.update(element);
            }
        }
    }
}
module.exports = DrawLineTool;